module.exports = __webpack_public_path__ + "img/location-text-img_720.f041c539.jpg";